




















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UPinControl extends Vue {
  // Props

  @Prop({ required: true })
  public isPinned!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isUpdating = false;
}
